export default __webpack_public_path__ + "static/media/img-b-result-distance-be_fr@3x.510024f9.jpg";